import ClPaper from '../ClPaper';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  components: {
    ClPaper
  }
})
export default class ClCard extends Vue {
  @Prop({
    default: false,
    type: Boolean
  })
  public raised!: boolean;
}
